import { InlineIcon } from "@iconify/react";
import { createUseStyles } from "react-jss";
import { ButtonHOC, DefaultBtn, DefaultMSFNavBtn, DefaultSearchBtn } from "../HOCs";
import {
  commonStylesBasic,
  commonStylesIconBasic,
  commonStylesPlaceholderBasic,
  commonStylesPlaceholderMSFNavBtn,
  commonStylesPlaceholderSearchBtn,
  getCommonStylesLabelBasic,
} from "../helpers";
import jssVariables from "../../../../jss_setup";

const commonButtonStyles = { ...commonStylesBasic };

const ButtonStyles = createUseStyles({
  placeholder: (props: any) => ({
    ...commonStylesPlaceholderBasic,
    borderRadius: commonButtonStyles.borderRadius,
    ...(props?.customStyles?.placeholder ?? {}),
  }),
  ButtonDefault: (props) => ({
    ...commonButtonStyles,
    display: "grid",
    gridTemplateColumns: props.showIcon ? "1fr max-content" : "1fr",
    gridGap: props.showIcon ? commonButtonStyles.gridGap : 0,
    background: jssVariables.colors.base_color,
    color: "white",
    border: `1px solid ${jssVariables.colors.base_color}`,
    ...(props?.customStyles?.ButtonDefault ?? {}),
  }),
  ButtonReverted: (props) => ({
    ...commonButtonStyles,
    display: "grid",
    gridTemplateColumns: props.showIcon ? "1fr max-content" : "1fr",
    gridGap: props.showIcon ? commonButtonStyles.gridGap : 0,
    background: "white",
    border: `1px solid ${jssVariables.colors.base_color}`,
    color: jssVariables.colors.base_color,
    "&:hover": {
      color: "white",
      background: jssVariables.colors.base_color,
    },
    ...(props?.customStyles?.ButtonReverted ?? {}),
  }),
  label: (props) => ({
    ...getCommonStylesLabelBasic(props),
    display: "grid",
    gridTemplateColumns: props.showIcon ? "1fr max-content" : "1fr",
    fontSize: props.size ? props.size : "medium",
    ...(props?.customStyles?.label ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    ButtonDefault: (props: any) => ({
      ...(props?.customStyles?.ButtonDefault?.smallscreen ?? {}),
    }),
    ButtonReverted: (props: any) => ({
      ...(props?.customStyles?.ButtonReverted?.smallscreen ?? {}),
    }),
    label: (props: any) => ({
      ...(props?.customStyles?.label?.smallscreen ?? {}),
    }),
  },
});
let Button = ({ text = "", showIcon = false, icon = "", ...props }: any) => {
  const classes = ButtonStyles({ customStyles: props.customStyles });
  return (
    <DefaultBtn {...{ classes, ...props }}>
      <span className={classes.label}>{text}</span>
      {showIcon && <InlineIcon icon={icon ? icon : "fa:angle-right"} className={classes.icon} />}
    </DefaultBtn>
  );
};
Button = ButtonHOC(Button, ButtonStyles);

// =============================== SEARCHBUTTON ===============================
const SearchButtonStyles = createUseStyles({
  placeholder: (props) => ({
    ...commonStylesPlaceholderSearchBtn,
    borderRadius: jssVariables.half_gap,
    ...(props?.customStyles?.placeholder ?? {}),
  }),
  SearchButton: (props) => ({
    ...commonButtonStyles,
    border: `2px solid ${jssVariables.colors.base_color}`,
    background: jssVariables.colors.base_color,
    color: "white",
    height: "2.5rem",
    fontSize: "large",
    minWidth: "7rem",
    "&:hover": {
      background: "white",
      color: jssVariables.colors.base_color,
    },
    ...(props?.customStyles?.SearchButton ?? {}),
  }),
  label: (props) => ({
    ...getCommonStylesLabelBasic(props),
    ...(props?.customStyles?.label ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    SearchButton: (props: any) => ({
      height: "3rem!important",
      ...(props?.customStyles?.SearchButton?.smallscreen ?? {}),
    }),
  },
});
let SearchButton = ({ loading = false, text = "", ...props }: any) => {
  const classes = SearchButtonStyles({ customStyles: props.customStyles });
  return (
    <DefaultSearchBtn {...props}>
      {loading ? (
        <InlineIcon icon="line-md:loading-twotone-loop" className={classes.icon} />
      ) : (
        <span className={classes?.label || ""}>{text}</span>
      )}
    </DefaultSearchBtn>
  );
};
SearchButton = ButtonHOC(SearchButton, SearchButtonStyles);

const MSFNavBtnStyles = createUseStyles({
  placeholder: (props) => ({
    ...commonStylesPlaceholderMSFNavBtn,
    borderRadius: commonButtonStyles.borderRadius,
    ...(props?.customStyles?.placeholder ?? {}),
  }),
  button: (props) => ({
    display: "grid",
    gridTemplateColumns: props.showIcon ? "1fr max-content" : "1fr",
    background: "none",
    borderBottom: `2px solid transparent`,
    fontWeight: "normal",
    padding: 0,
    "&:hover:enabled": {
      borderBottom: `2px solid ${jssVariables.colors.base_color}`,
      fontWeight: "bold",
    },
    "&:disabled": {
      borderBottom: `2px solid ${jssVariables.colors.base_color}`,
      fontWeight: "bold",
      cursor: "unset",
    },
    ...(props?.customStyles?.ButtonDefault ?? {}),
  }),
  label: (props: any) => ({
    ...getCommonStylesLabelBasic(props),
    color: "black",
    fontSize: "large",
    textTransform: "uppercase",
    fontWeight: "inherit",
    ...(props?.customStyles?.label ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    button: (props: any) => ({
      ...(props?.customStyles?.button?.smallscreen ?? {}),
    }),
  },
});
var MSFNavBtn = ({ text = "", ...props }) => {
  const classes = MSFNavBtnStyles({ customStyles: props.customStyles });
  return (
    <DefaultMSFNavBtn {...props}>
      <span className={classes?.label || ""}>{text}</span>
    </DefaultMSFNavBtn>
  );
};
MSFNavBtn = ButtonHOC(MSFNavBtn, MSFNavBtnStyles);

export { Button, SearchButton, MSFNavBtn };
